import { getVendedores, createVendedor, updateVendedor, deleteVendedor, getVendedorAtributos } from '../models/vendedorModel';
import Swal from 'sweetalert2';
import pb from '../lib/pocketbase';
import { toasts } from "svelte-toasts";

export async function fetchVendedores(page, perPage) {
  try {
    const response = await getVendedores(page, perPage);
    return {
      vendedor: response.items,
      totalRecords: response.totalItems,
      currentPage: response.page,
    };
  } catch (error) {
    console.error("Error fetching vendedores:", error);
    Swal.fire('Error', 'No se pudieron cargar los vendedores', 'error');
    return null;
  }
}

export async function saveVendedor(vendedor, currentVendedorId) {
  let vendedorId;

  try {
    if (currentVendedorId) {
      await updateVendedor(currentVendedorId, vendedor);
      vendedorId = currentVendedorId;

      toasts.add({
        title: 'Éxito',
        description: 'Vendedor guardado exitosamente',
        duration: 3000, // Duración de 3 segundos
        placement: 'bottom-right',
        type: 'success',
        theme: 'dark',
        showProgress: true
      });
    } else {
      const newVendedor = await createVendedor(vendedor);
      vendedorId = newVendedor.id;

      toasts.add({
        title: 'Éxito',
        description: 'Vendedor creado exitosamente',
        duration: 3000, // Duración de 3 segundos
        placement: 'bottom-right',
        type: 'success',
        theme: 'dark',
        showProgress: true
      });
    }
    // Llamar a saveAtributosVendedor después de guardar el vendedor
    if (vendedor['atributos'] && vendedor['atributos'].length > 0) {
      console.log('vendedor:', vendedor);
      await saveAtributosVendedor(vendedorId, vendedor['atributos']);
    }
  } catch (error) {
    console.error("Error saving vendedor:", error);
    toasts.add({
      title: 'Error',
      description: 'Ocurrió un error al guardar el vendedor',
      duration: 3000,
      placement: 'bottom-right',
      type: 'error',
      theme: 'dark',
      showProgress: true
    });
  }
}

export async function removeVendedor(id) {
  try {
    await deleteVendedor(id);
    toasts.add({
      title: 'Éxito',
      description: 'Vendedor eliminado exitosamente.',
      duration: 3000,
      placement: 'bottom-right',
      type: 'error',
      theme: 'dark',
      showProgress: true
    });
  } catch (error) {
    console.error("Error deleting vendedor:", error);
    Swal.fire('Error', 'No se pudo eliminar el vendedor', 'error');
  }
}

// Suscripción en tiempo real a cambios en la colección 'vendedor'
export function subscribeToVendedores(searchQuery, handleSearch) {
  pb.collection('vendedor').subscribe('*', async (e) => {
    console.log('Evento en tiempo real recibido:', e);
    await handleSearch(1); // Actualiza la lista con la primera página
  });
}

// Desuscripción de los eventos en tiempo real
export function unsubscribeFromVendedores() {
  pb.collection('vendedor').unsubscribe('*');
}

export async function searchVendedores(query, page = 1, perPage = 10) {
  const response = await pb.collection('vendedor').getList(page, perPage, {
    filter: `nombre ~ "${query}"`,
  });
  return {
    vendedor: response.items,
    totalRecords: response.totalItems,
    currentPage: response.currentPage,
  };
}

export async function fetchAtributosVendedor(id) {
  try {
    const response = await getVendedorAtributos(id);
    return {
      atributos: response,
    };
  } catch (error) {
    console.error("Error fetching vendedores:", error);
    Swal.fire('Error', 'No se pudieron cargar los vendedores', 'error');
    return null;
  }
}

export async function saveAtributosVendedor(vendedorId, atributos) {
  // Elimina los atributos existentes antes de guardar los nuevos
  await deleteAtributosVendedor(vendedorId);
  
  try {
    // Itera sobre cada atributo y guarda/actualiza en la colección 'atributo_vendedor'
    for (const { atributo, valor } of atributos) {
      await pb.collection('atributo_vendedor').create({
        vendedor: vendedorId,
        atributo: atributo.id,
        valor,
      });
    }

    toasts.add({
      title: 'Éxito',
      description: 'Atributos actualizados exitosamente',
      duration: 3000,
      placement: 'bottom-right',
      type: 'success',
      theme: 'dark',
      showProgress: true,
    });
  } catch (error) {
    console.error('Error guardando atributos:', error);
    toasts.add({
      title: 'Error',
      description: 'No se pudieron guardar los atributos',
      duration: 3000,
      placement: 'bottom-right',
      type: 'error',
      theme: 'dark',
      showProgress: true,
    });
  }
}

export async function deleteAtributosVendedor(vendedorId) {
  try {
    // Recupera los atributos del vendedor
    const response = await pb.collection('atributo_vendedor').getList(1, 50, {
      filter: `vendedor="${vendedorId}"`,
    });

    // Elimina cada atributo individualmente
    const deletePromises = response.items.map((item) =>
      pb.collection('atributo_vendedor').delete(item.id)
    );

    await Promise.all(deletePromises);
    console.log('Atributos eliminados correctamente');
  } catch (error) {
    console.error('Error eliminando atributos del vendedor:', error);
    throw new Error('No se pudieron eliminar los atributos');
  }
}